<button mat-icon-button aria-label="close dialog" mat-dialog-close="cancelled">
  <i class="fa-light fa-xmark"></i>
</button>
